import React from 'react'

export const YearExercises = [
  {
    name: 'list',
    component: React.lazy(() => import('modules/admin/general-parameters/yearExercises/YearExercisesList')),
    path: '/admin/general-parameters/year-exercises',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
  {
    name: 'create',
    component: React.lazy(() => import('modules/admin/general-parameters/yearExercises/YearExercisesCreate')),
    path: '/admin/general-parameters/year-exercises/create',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
  {
    name: 'edit',
    component: React.lazy(() => import('modules/admin/general-parameters/yearExercises/YearExercisesEdit')),
    path: '/admin/general-parameters/year-exercises/edit/:yearExerciseId',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
]
